export type DealClassification = 'strategy' | 'sector';

export interface ClassificationColumn {
  columnDef: DealClassification;
  headerLabel: string;
  field: DealClassification;
}

export interface SeriesTableConfig {
  classification: ClassificationColumn;
  showSubtotalPerformance: boolean;
  deals: {
    columns: string[];
    expandedColumns: string[];
  };
  qRoll: {
    columns: string[];
    innerColumns: string[];
    headers: string[];
  };
}

const StrategyCol: ClassificationColumn = { columnDef: 'strategy', headerLabel: 'Strategy', field: 'strategy' };
const SectorCol: ClassificationColumn = { columnDef: 'sector', headerLabel: 'Sector', field: 'sector' };

const qRollCols = ['name', 'realizationType', 'priorNAV', 'qoQContributions', 'qoQDistributions', 'qoQGainLoss', 'nav', 'qoQTvpiChange', 'qoQIrrChange'];
const qRollInnerCols = ['holdingName', 'realizationType', 'holdingPriorNAV', 'holdingQoQContributions', 'holdingQoQDistributions', 'holdingQoQGainLoss', 'holdingNav', 'holdingQoQTvpiChange', 'holdingQoQIrrChange'];
const qRollHeaders = ['nameHeader', 'priorNAVHeader', 'qoQContributionsHeader', 'qoQDistributionsHeader', 'qoQGainLossHeader', 'navHeader', 'qoQTvpiChangeHeader', 'qoQIrrChangeHeader'];

const dealsColumns = (c: ClassificationColumn): string[] =>
  ['name', c.columnDef, 'commitment', 'contributions', 'distributions', 'nav', 'totalValue', 'tvpi', 'irr'];

const dealsExpandedColumns = (c: ClassificationColumn): string[] =>
  ['name', 'realizationType', c.columnDef, 'vintageYear', 'valuationDate', 'commitment', 'contributions', 'remainingCommitment', 'distributions', 'reportedValue', 'subsequentContributions', 'subsequentDistributions', 'fxGainLoss', 'nav', 'totalValue', 'tvpi', 'irr'];

function makeConfig(classification: ClassificationColumn, showSubtotalPerformance: boolean): SeriesTableConfig {
  return {
    classification,
    showSubtotalPerformance,
    deals: { columns: dealsColumns(classification), expandedColumns: dealsExpandedColumns(classification) },
    qRoll: { columns: qRollCols, innerColumns: qRollInnerCols, headers: qRollHeaders },
  };
}

export const defaultSeriesTableConfig = makeConfig(StrategyCol, true);

export const seriesTableConfigs: Record<string, SeriesTableConfig> = {
  'real estate': makeConfig(SectorCol, false),
  'private equity': makeConfig(StrategyCol, true),
};

export function resolveSeriesTableConfig(assetClasses: string[] | undefined): SeriesTableConfig {
  const key = assetClasses?.length === 1 ? assetClasses[0]?.toLowerCase() : undefined;
  return (key ? seriesTableConfigs[key] : undefined) ?? defaultSeriesTableConfig;
}
